import axios from "../axios";

const subscribe = (data) => axios.post("/subscribers/subscribe", data);

const changePlan = (data) => axios.post("/subscribers/change", data);

const customerSubscriptionService = {
  subscribe,
  changePlan,
};

export default customerSubscriptionService;
